// Абсолютний URL до файлу, який роздає бекенд (аватари в /uploads).
// avatarUrl зберігається як відносний шлях ("/uploads/..."), а origin беремо
// з REACT_APP_API_BASE (без "/apiV1").
const BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5001/apiV1';
export const API_ORIGIN = BASE.replace(/\/apiV1\/?$/, '');

export const mediaUrl = (p) => {
  if (!p) return '';
  if (/^(https?:\/\/|data:)/.test(p)) return p; // вже абсолютний або вбудований data-URI
  return `${API_ORIGIN}${p}`;
};
